import { takeLatest, call, put, all } from 'redux-saga/effects';

// SERVICES
import { ApiResponse, postApi } from 'services/_api';
import { CHANNEL, PATH_DETRAN_CNH } from 'services/_path';

// TYPES
import { ReducerAction } from 'store/modules/types';
import { Types, IRequestAgendarExameMedico } from './types';

// ACTIONS
import {
	agendarExameMedicoSuccess,
	agendarExameMedicoFailure,
} from './actions';

function* agendarExameMedico(request: ReducerAction) {
	const { payload }: { payload: IRequestAgendarExameMedico } = request;

	const response: ApiResponse = yield call(
		postApi,
		PATH_DETRAN_CNH,
		`divisao-equitativa/${CHANNEL}/agendar-exame-medico`,
		payload,
	);

	if (response.status === 200) {
		yield put(agendarExameMedicoSuccess(response));
	} else if (response.error) {
		yield put(agendarExameMedicoFailure(response.error));
	}
}

export default all([
	takeLatest(Types.AGENDAR_EXAME_MEDICO, agendarExameMedico),
]);
